import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import round from 'lodash/round';

import Price from 'Components/Utility/Price/Price';
import 'Features/PickAndMix/components/Commerce/PickAndMixTierBoxes.scss';
import { currencyCode } from 'Helpers/Geo/data';

const PickAndMixTierBoxes = ({
  tiers,
  bundleTypeMessage,
  selectedProducts,
  products,
}) => {
  if (tiers && tiers.length < 1) return false;
  const selectedProductCount = (selectedProducts && selectedProducts.length) || 0;
  const quantities = tiers.map(p => p.quantity);


  const isSelected = (qty, i) => {
    const nextTier = i + 1;
    const isLastTier = nextTier === tiers.length;

    return (selectedProductCount === qty) ||
      (selectedProductCount > qty && !isLastTier && selectedProductCount < quantities[nextTier]) ||
      (isLastTier && selectedProductCount >= qty);
  };

  const productsCount = products && products.length;

  const formatTierMessage = tier => `${tier.quantity} ${productsCount === tier.quantity ? '' : '+'} ${bundleTypeMessage}`;

  return (
    <section className="PickAndMixTierBoxes">
      {tiers.map((tier, i) =>
        <div className={classNames('PickAndMixTierBox', { 'PickAndMixTierBox--selected': isSelected(tier.quantity, i) })} key={tier.quantity}>
          <div className="PickAndMixTierBox__quantity">

            {formatTierMessage(tier)}

            {((i + 1) === tiers.length) && (tiers.length > 1) &&
              <span className="PickAndMixTierBox__quantity__bestValueLabel">
                <FormattedMessage
                  id="PickAndMixTierBoxes.bestvalue"
                  defaultMessage="Best value"
                />
              </span>
            }
          </div>
          <div className="PickAndMixTierBox__price">
            <Price price={{
              [currencyCode]: round(((tier.price[currencyCode] / tier.quantity) / 100), 2) * 100,
            }}
            />
            <span className="PickAndMixTierBox__price__perItem">/</span>
            <span className="PickAndMixTierBox__price__perItem">
              <FormattedMessage
                id="PickAndMixTierBoxes.peritem"
                defaultMessage="Per item"
              />
            </span>
          </div>

        </div>,
      )}
    </section>
  );
};


PickAndMixTierBoxes.propTypes = {
  tiers: PropTypes.arrayOf(PropTypes.object),
  bundleTypeMessage: PropTypes.string,
  selectedProducts: PropTypes.arrayOf(PropTypes.object),
  products: PropTypes.arrayOf(PropTypes.object),
};

PickAndMixTierBoxes.defaultProps = {
  tiers: [],
  bundleTypeMessage: '',
  selectedProducts: [],
  products: [],
};

export default PickAndMixTierBoxes;
